<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
          Employees who provide direct care may be required to provide
          individuals in services with transportation to ensure access to the
          community as needed. Employees who transport individuals in services
          both in company and personal vehicles must make certain all
          transportation meets the following requirements
        </p>

        <div class="ml-5">
          <p class="text-caption"></p>

          <ul class="text-caption">
            <li>
              All transportation must be done in accordance with all applicable
              state laws (e.g., speed limit, appropriate use of turn signals,
              etc.).
            </li>
            <li>
              Individuals in services are not to be left unattended in the
              vehicle.
            </li>
            <li>
              Individuals in services and employees must use seat belts and
              remain seated while the vehicle is in motion.
            </li>
            <li>
              Keys are removed from the vehicles at all times if the driver is
              not in the front seat, unless the driver is actively operating a
              wheelchair lift or ramp that requires the keys to be in the
              ignition.
            </li>
            <li>
              Individuals in services who use a wheelchair must use seat belts
              or locking mechanisms to immobilize and secure the wheelchair
              during travel.
            </li>
            <li>
              If applicable, individuals in services must be transported with
              safety restraints or harnesses in place in accordance with the
              individuals’ Behavior Support Plan and approved human rights
              restrictions.
            </li>
            <li>
              Vehicles used for transporting individuals in services must have
              working door locks.
            </li>
            <li>
              Doors must be locked at all times while a vehicle is in motion.
            </li>
            <li>
              Individuals in services must arrive safely at the scheduled time
              and arranged destination.
            </li>
            <li>
              Individuals in services are not to be left alone along the way to
              or from day supports even in emergency situations or when the
              health and safety of others may be in question.
            </li>
            <li>
              If necessary during an emergency, the driver may wait until
              another driver arrives to complete the transport.
            </li>
            <li>
              Unless they are actively transporting an individual in services,
              employees shall not park a company vehicle with handicap license
              plates or a hangtag in a handicap parking space.
            </li>
            <li>
              Employees may not, under any circumstance, use a cell phone or
              other technology for any purpose while transporting individuals in
              services.
            </li>
            <li>
              Auto insurance claims for accidents that occur in the personal
              vehicle of an employee while transporting {{ userCompany }} clients
              must go through the personal auto insurance of the employee.
            </li>
            <li>
              Employees may not, under any circumstance, leave the scene of an accident.
            </li>
            <li>
              Accidents that are determined to be due to driver negligence will be the sole responsibility
              of the driver.
            </li>
          </ul>
        </div>

        <div class="text-caption mt-5">
          <b>Please check the applicable box below</b>
        </div>
        <div class="ml-5">
          <div class="text-caption"></div>
          <v-checkbox
            class="text-caption"
            v-model="isRead"
            label="I have read, understand, and agree to implement all transportation requirements listed above when transporting
individuals in services in a company and/or personal vehicle"
          ></v-checkbox>
          <v-checkbox
            class="text-caption mt-n2"
            v-model="isLicense"
            label="I do not have a driver license and, therefore, will not drive a company or personal vehicle while on the job.
However, I have read, understand, and agree to implement all transportation requirements listed above if, at any
point in time, I obtain a driver license and am able to transport individuals in services in a company and/or
personal vehicle. I will provide the Human Resources Department with a copy of my driver license within 7 days
of obtaining the driver license"
          ></v-checkbox>
          <v-checkbox
            class="text-caption mt-n2"
            v-model="isInsurance"
            label="I do not have auto insurance due to lack of access to a personal vehicle and, therefore, will not drive a personal
vehicle while on the job. However, I have read, understand, and agree to implement all transportation
requirements listed above if, at any point in time, I transport individuals in services in a company vehicle and/or
obtain auto insurance for a personal vehicle and am able to transport individuals in a personal vehicle. I will
provide the Human Resources Department proof of insurance within 7 days of obtaining auto insurance. "
          ></v-checkbox>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInClientTranspo"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
         <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedInClientTranspo"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedInClientTranspo"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
      isRead: "",
      isInsurance: "",
      isLicense: "",
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInClientTranspo");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInClientTranspo = data;
      localStorage.setItem("employeeSignatureInClientTranspo", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('dateSignedInClientTranspo', this.dateSignedInClientTranspo);
        localStorage.setItem('isRead', this.isRead);
        localStorage.setItem('isLicense', this.isLicense);
        localStorage.setItem('isInsurance', this.isInsurance);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

      const dateSigned = localStorage.getItem('dateSignedInClientTranspo');
      const isread = localStorage.getItem('isRead');
      const islicense = localStorage.getItem('isLicense');
      const isinsurance = localStorage.getItem('isInsurance');

      if (dateSigned !== null) {
         this.dateSignedInClientTranspo= dateSigned;
      }
      if (isread !== null) {
         this.isRead= isread;
      }
      if (islicense !== null) {
         this.isLicense= islicense;
      }
      if (isinsurance !== null) {
         this.isInsurance= isinsurance;
      }

      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
